import http from '@/http-common'
import {ApiService} from '@/services/ApiService'

const URL = '/api/connection'

class ConnectionService extends ApiService {
    constructor(){
        super()
    }
    getUrl(){
        return URL
    }
    syncInvoices(connectionId){
        return http.get(`${this.getUrl()}/${connectionId}/invoices`)
    }
    list(customerId) {
        var queryUrl = '?list_destinations=true&id='+customerId
        return http.get(`${this.getUrl()}` + queryUrl)
    }
}

export default new ConnectionService()